import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/MikroAccount";

export const GetAll = (options) => GENERATE_URL(PREFIX_URL, options);

export const UpdatePaymentTermSurchargeServiceCode = (options) =>
  GENERATE_URL(
    `${PREFIX_URL}/:id/payment-term-surcharge-service-code`,
    options
  );

export default {
  GetAll,
  UpdatePaymentTermSurchargeServiceCode,
};
